import { render } from "./StatsDisplay.vue?vue&type=template&id=3e79b6a3&scoped=true"
import script from "./StatsDisplay.vue?vue&type=script&lang=js"
export * from "./StatsDisplay.vue?vue&type=script&lang=js"

import "./StatsDisplay.vue?vue&type=style&index=0&id=3e79b6a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e79b6a3"]])

export default __exports__